import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  fetchSingleScenario,
  triggerScenariosInit,
  triggerScenarios,
  saveTypologySegments,
  fetchScenarioTypologies
} from '../../../redux/actions/trm/trmDashboard';
import { getCategories, getLiveSets } from '../../../redux/actions/settings';
import ConfigureScenario from './configureScenario';

function mapStateToProps(state) {
  const { trmDashboard = {}, settings = {} } = state;
  /*
   * Create Run instance reducers:
   * - typologySegment
   */
  const { singleScenario = {}, typologySegment = {} } = trmDashboard;
  const { createRunInstanceCategories = {}, createRunInstanceLiveSets = {} } =
    settings;
  const { isLoading, data, error } = singleScenario;
  return {
    isLoading,
    error,
    scenario: data,
    authentication: state.authentication,
    createRunInstanceCategories, // look at this for category list
    trmDashboard, // look at this for typology list fetched
    typologySegment, // look at this for saving typology segment sets
    createRunInstanceLiveSets //look at this for combinations of sets
  };
}

function mapDispatchToProps(dispatch) {
  return {
    scenarioAPIActions: bindActionCreators(
      { fetchSingleScenario, triggerScenariosInit, triggerScenarios },
      dispatch
    ),
    // look here for create run instance related actions
    configureRunInstanceAPIActions: bindActionCreators(
      {
        saveTypologySegments,
        getCategories,
        fetchScenarioTypologies,
        getLiveSets
      },
      dispatch
    )
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfigureScenario);
